import React from "react";
import { connect } from "react-redux";
import {
  Row,
  Col,
  InputGroup,
  InputGroupText,
  Input,
  Button,
  Alert,
} from "reactstrap";
import {
  getEventTypes,
  getVenues,
  saveEventType,
  saveAdHocEvent,
  getEventTypeDetails,
} from "../../actions/eventActions";
import SidebarProgress from "./Components/Sidebar/sidebar-progress";
import FormField from "./Components/Common/FormField";
import EventTypeModal from "./Components/Modals/EventTypeModal";
import NumberField from "./Components/Common/NumberField";
import { Formik, Form } from "formik";
import { Link } from 'react-router-dom';
import Loader from "../../components/Loader/Loader";
import * as Yup from "yup";
import { Component } from "react";
import qs from "query-string";
import { notification, withRouter, BACKEND_API_BASE_URL, FRONTEND_BASE_URL } from "../../utils/utility";
import { sendGetRequest } from "../../actions/app-actions";
import isEmpty from "../../validation/is-empty";
import { getAdminBusinessId } from "../../utils/authHelper";
import { GOOGLE_MEET_APP_ID, ZOOM_APP_ID, MICROSOFT_TEAMS_ID } from "../../data/integration-app";
import useFeatureRedirect from "../../hooks/useFeatureRedirect";
import usePlanLimitRedirect from "../../hooks/usePlanLimitRedirect";
import { FEATURE_IDS } from "../../constants/featureAccess";
import FeatureLock from "../../components/FeatureLock/FeatureLock";
const validation = Yup.object().shape({
  event_name: Yup.string().required("Event Name is required."),
  event_format_id: Yup.string().required("Event Type is required."),
  venue_id: Yup.string().required("Venue is required."),
  event_url: Yup.string().required("Event Url is required."),
});

let initialValues = {
  event_name: "",
  no_of_attendies: 1,
  event_format_id: 1,
  venue_id: "",
  event_url: "",
  venue_location: "",
  venue_location_notes: "",
  venue_location_status: "",
  call_my_invitee_status: "no",
  invitee_call_me_status: "no",
  host_phone_no: "",
  venue_other_notes: "",
  venue_other_display_status: "",
};

class AddNewEvent extends Component {



  constructor(props) {
    super(props);
    this.formRef = React.createRef();
    this.state = {
      isLoading: false,
      errorMessage: "",
      eventTypes: [
        {
          label: "One-on-One",
          value: 1,
        },
        {
          label: "Group",
          value: 2,
        },
      ],
      isOpen: false,
      venues: [],
      pageLoading: false,
      eventId: "",
      connectedVenues:[]
    };
  }

  /**
   * Get event type
   * @returns 
   */
  getType = () => {
    const { router } = this.props;
    const { location } = router || {};
    const { search } = location || {};
    const locationParse = qs.parse(search);
    const { type } = locationParse || {};
    return type;
  }

  /**
   * Get id
   */
  getId = () => {
    const { router } = this.props;
    const { params } = router || {};
    const { id } = params || {};
    return id;
  }

  componentDidMount() {
    const { getEventTypeDetails, sendGetRequest } = this.props;

    // get event details
    const _this = this;
    const id = _this.getId();
    this.setState({
      pageLoading: true,
    });
    sendGetRequest({
        url: `/admin/connected-venues/${getAdminBusinessId()}`,
        onSuccess: function (response) {
          _this.setState({
            connectedVenues: response.data
          })
        },
        onError: function (error) {
        },
    });

    if (id) {
      getEventTypeDetails({
        data: {
          id,
        },
        onSuccess: function (details) {
          initialValues = {
            ...initialValues,
            ...details,
          };

          _this.setState({
            pageLoading: false,
            eventId: id,
          });
        },
        onError: function (error) {
          _this.setState({
            pageLoading: false,
          });
        },
      });
    } else {

      initialValues = {
        ...initialValues,
        event_name: "",
        no_of_attendies: 1,
        event_format_id: 1,
        venue_id: "",
        event_url: "",
        venue_location: "",
        venue_location_notes: "",
        venue_location_status: "",
        call_my_invitee_status: "no",
        invitee_call_me_status: "no",
        host_phone_no: "",
        venue_other_notes: "",
        venue_other_display_status: "",
      };

      _this.setState({
        pageLoading: false,
      });

    }

    // veneues
    Promise.all([
      this.getVenues(),
    ])
      .then((value) => {
        let data = [];
        value.forEach((e) => {
          data.push(e);
        });
        this.setState({
          venues: data[0],
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getVenues = () => {
    return new Promise((resolve) => {
      const { getVenues: getLocalVenues } = this.props;
      getLocalVenues({
        onSuccess: (data) => {
          resolve(data);
        },
      });
    });
  };

  transformValue = (options, key) => {
    let values = [];
    if ((options || []).length > 0) {
      values = (options || []).map((option) => {
        let { name, id } = option || {};

        if (key === "eventTypes") {
          const { event_type } = option || {};
          name = event_type;
        }

        if (key === "venues") {
          const { venue } = option || {};
          name = venue;
        }

        // Go to Meeting (id 6) retired — keep out of venue picker
        if (key === "venues" && parseInt(id, 10) === 6) {
          return null;
        }

        return {
          ...option,
          label: name,
          value: id,
        };
      }).filter(Boolean);
    }

    return values;
  };

  toggleModal = () => {
    const { isOpen } = this.state;
    this.setState({
      isOpen: !isOpen,
    });
  };

  /**
   * on cancel button handler
   */
  onCancel = () => {
    const { router } = this.props;
    const { navigate } = router || {};
    navigate(-1);
  };

  /**
   * save event as draft
   */
  onSaveAsDraft = () => {
    const data = this.formRef.current.values;
    const { saveEventType } = this.props;
    const type = this.getType();

    const bussinessId = localStorage.getItem("businessId");

    const { eventId } = this.state || {};

    const {
      event_name,
      venue_location,
      venue_other_display_status,
      venue_other_notes,
      venue_location_notes,
      venue_location_status,
      no_of_attendies,
      event_format_id,
      venue_id,
      event_url,
      invitee_call_status,
      host_phone_no,
    } = data || {};

    if (parseInt(venue_id) === 1) {
      // const { venue_location, venue_location_notes, venue_location_status} = values || {};

      if (venue_location === "") {
        notification.error("Venue locatation is required.");
        return;
      }

      // if(venue_location_notes === "") {
      //     alert("Venue locatation notes is required.");
      //     return;
      // }

      if (venue_location_status === "") {
        notification.error("Venue locatation status is required.");
        return;
      }
    }

    if (parseInt(event_format_id) === 2 && parseInt(no_of_attendies) < 2) {
      notification.error("No of attendies should be greater than 1.");
      return;
    }

    // Feature gate: block Group Events for plans that don't include it
    const { featureAccess } = this.props;
    const { features: draftFeatures = [] } = featureAccess || {};
    const groupEnabledDraft = draftFeatures.some(
      (f) => f.feature_id === FEATURE_IDS.GROUP_EVENTS && f.status === "E"
    );
    if (parseInt(event_format_id) === 2 && !groupEnabledDraft) {
      notification.error(
        "Your current plan does not include Group Events. Please upgrade your subscription."
      );
      return;
    }

    if (parseInt(venue_id) === 2) {
      // const { invitee_call_status, host_phone_no } = values || {};

      if (invitee_call_status === "") {
        notification.error("Invitee call status is required.");
        return;
      }

      if (invitee_call_status === "invitee" && host_phone_no === "") {
        notification.error("Host phone number is required.");
        return;
      }
    }

    let defaultValue = {
      event_name,
      no_of_attendies,
      event_format_id,
      venue_id,
      event_url,
      is_event_paid: type === "paid-event" ? "E" : "D",
      business_id: bussinessId,
    };

    if (venue_id === 1 || venue_id === "1") {
      defaultValue = {
        ...defaultValue,
        venue_location,
        venue_location_notes,
        venue_location_status,
      };
    }

    if (venue_id === "2" || venue_id === 2) {
      defaultValue = {
        ...defaultValue,
        invitee_call_status,
        host_phone_no,
      };
    }

    if (venue_id === "7" || venue_id === 7) {
      defaultValue = {
        ...defaultValue,
        venue_other_notes,
        venue_other_display_status,
      };
    }

    this.setState({
      isLoading: true,
    });

    saveEventType({
      data: defaultValue,
      eventId,
      onSuccess: (eventId) => {
        const { router } = this.props;
        const { navigate } = router || {};
        navigate("/admin/events/list");
      },
      onError: (message) => {
        this.setState({
          errorMessage: message,
          isLoading: false,
        });
        console.log("error handler");
      },
    });
    /*
    this.setState({
      isSaveDraftEvent: true,
    });
    const { submitForm } = useFormikContext();
    submitForm();
    */
  };

  render() {
    const type = this.getType();
    const { eventTypes, venues, errorMessage, isLoading, pageLoading, isOpen, connectedVenues } =
      this.state;
    return (
      <div className="create-event-wrapper">
        <div className="create-event-container">
          <Row className="flex-column-reverse flex-lg-row">
            <Col lg="9">
              <div className="event-card">
                <div className="event-card-head">
                  <h3 className="event-title">Event Type</h3>
                </div>
                {pageLoading ? (
                  <Loader isShowLoader={true} />
                ) : (
                  <Formik
                    innerRef={this.formRef}
                    validationSchema={validation}
                    initialValues={initialValues}
                    enableReinitialize
                    onSubmit={(data) => {
                      const { saveEventType } = this.props;
                      const bussinessId = localStorage.getItem("businessId");

                      const { eventId } = this.state || {};

                      const {
                        event_name,
                        venue_location,
                        venue_other_display_status,
                        venue_other_notes,
                        venue_location_notes,
                        venue_location_status,
                        no_of_attendies,
                        event_format_id,
                        venue_id,
                        event_url,
                        invitee_call_status,
                        host_phone_no,
                      } = data || {};

                      if (parseInt(venue_id) === 1) {
                        // const { venue_location, venue_location_notes, venue_location_status} = values || {};

                        if (venue_location === "") {
                          alert("Venue locatation is required.");
                          return;
                        }

                        // if(venue_location_notes === "") {
                        //     alert("Venue locatation notes is required.");
                        //     return;
                        // }

                        if (venue_location_status === "") {
                          alert("Venue locatation status is required.");
                          return;
                        }
                      }

                      if (
                        parseInt(event_format_id) === 2 &&
                        parseInt(no_of_attendies) < 2
                      ) {
                        alert("No of attendies should be greater than 1.");
                        return;
                      }

                      // Feature gate: block Group Events for plans that don't include it
                      const { featureAccess: fa } = this.props;
                      const { features: submitFeatures = [] } = fa || {};
                      const groupEnabledSubmit = submitFeatures.some(
                        (f) => f.feature_id === FEATURE_IDS.GROUP_EVENTS && f.status === "E"
                      );
                      if (parseInt(event_format_id) === 2 && !groupEnabledSubmit) {
                        this.setState({
                          errorMessage:
                            "Your current plan does not include Group Events. Please upgrade your subscription.",
                        });
                        return;
                      }

                      if (parseInt(venue_id) === 2) {
                        // const { invitee_call_status, host_phone_no } = values || {};

                        if (invitee_call_status === "") {
                          alert("Invitee call status is required.");
                          return;
                        }

                        if (
                          invitee_call_status === "invitee" &&
                          host_phone_no === ""
                        ) {
                          alert("Host phone number is required.");
                          return;
                        }
                      }

                      let defaultValue = {
                        event_name,
                        no_of_attendies,
                        event_format_id,
                        venue_id,
                        event_url,
                        is_event_paid: type === "paid-event" ? "E" : "D",
                        business_id: bussinessId,
                      };

                      if (venue_id === 1 || venue_id === "1") {
                        defaultValue = {
                          ...defaultValue,
                          venue_location,
                          venue_location_notes,
                          venue_location_status,
                        };
                      }

                      if (venue_id === "2" || venue_id === 2) {
                        defaultValue = {
                          ...defaultValue,
                          invitee_call_status,
                          host_phone_no,
                        };
                      }

                      if (venue_id === "7" || venue_id === 7) {
                        defaultValue = {
                          ...defaultValue,
                          venue_other_notes,
                          venue_other_display_status,
                        };
                      }

                      this.setState({
                        isLoading: true,
                      });

                      saveEventType({
                        data: defaultValue,
                        eventId,
                        onSuccess: (eventId) => {
                          const { router } = this.props;
                          const { navigate } = router || {};
                          navigate(
                            `/admin/events/create/${eventId}/step-2?type=${type}`
                          );
                        },
                        onError: (message) => {
                          this.setState({
                            errorMessage: message,
                            isLoading: false,
                          });
                        },
                      });
                    }}
                  >
                    {(formProps) => {
                      const {
                        values,
                        errors,
                        touched,
                        handleChange,
                        setFieldTouched
                      } = formProps;

                      // Compute group feature access for this render
                      const { featureAccess: faRender } = this.props;
                      const { features: renderFeatures = [], loaded: featuresReady } = faRender || {};
                      const groupFeatureEnabled = featuresReady
                        ? renderFeatures.some(
                            (f) => f.feature_id === FEATURE_IDS.GROUP_EVENTS && f.status === "E"
                          )
                        : true; // optimistic until features load

                      // Show Group in the dropdown when:
                      // (a) feature is enabled on the plan, OR
                      // (b) the current value is already 2 (editing an existing group event —
                      //     display is allowed; the backend gate blocks any re-save as group)
                      const isCurrentlyGroup = parseInt(values.event_format_id) === 2;
                      const availableEventTypes = (groupFeatureEnabled || isCurrentlyGroup)
                        ? eventTypes
                        : eventTypes.filter((t) => t.value !== 2);

                      return (
                        <Form>
                          <div className="event-card-body">
                            <Row>
                              <Col md="6" lg="6">
                                <FormField
                                  type="text"
                                  name="event_name"
                                  label="Event Name *"
                                  placeholder="Name"
                                  showLabel={true}
                                  tootipCode="P1F1"
                                  value={values.event_name}
                                  errors={errors}
                                  touched={touched}
                                  onChange={({ target }) => {
                                    const { value } = target;
                                    const url = value.replace(/\s/g, "-");

                                    handleChange({
                                      target: { name: "event_name", value },
                                    });

                                    handleChange({
                                      target: {
                                        name: "event_url",
                                        value: url.toLowerCase(),
                                      },
                                    });
                                  }}
                                />
                              </Col>
                              <Col md="6" lg="6">
                                <FormField
                                  showLabel
                                  placeholder="Select Event Format"
                                  showPlaceholder={false}
                                  type="select"
                                  name="event_format_id"
                                  label="Select Event Format *"
                                  tootipCode="P1F2"
                                  errors={errors}
                                  touched={touched}
                                  value={values.event_format_id}
                                  options={availableEventTypes}
                                />
                              </Col>
                            </Row>
                            <Row>
                              {(values.event_format_id === "2" ||
                                values.event_format_id === 2) && (
                                  <Col md="4" lg="4">
                                    <FeatureLock featureId={FEATURE_IDS.GROUP_EVENTS}>
                                    <div className="form-group">
                                      <label>
                                        No. of Attendees *
                                      </label>
                                      <NumberField
                                        defaultValue={parseInt(
                                          values.no_of_attendies
                                        )}
                                        onChange={(value) => {
                                          handleChange({
                                            target: {
                                              name: "no_of_attendies",
                                              value,
                                            },
                                          });
                                        }}
                                      />
                                    </div>
                                    </FeatureLock>
                                  </Col>
                                )}
                              <Col xl="8">
                                <div className="form-group form-field-group">
                                  <label>
                                    Event Url *
                                    {/* <ToolTip /> */}
                                  </label>
                                  <InputGroup addonType="prepend" className="event_urll">
                                    <InputGroupText>
                                      {FRONTEND_BASE_URL}{getAdminBusinessId()}/
                                    </InputGroupText>
                                    <Input
                                      placeholder="Event URL"
                                      name="event_url"
                                      onChange={({ target }) => {
                                        const { value, name } = target || {};
                                        handleChange({
                                          target: { name, value },
                                        });
                                      }}
                                      value={values.event_url}
                                    />
                                  </InputGroup>
                                  {errors["event_url"] &&
                                    touched["event_url"] && (
                                      <div className="form-field text-danger">
                                        {" "}
                                        {errors["event_url"]}{" "}
                                      </div>
                                    )}
                                </div>
                              </Col>
                            </Row>
                            <Row className="venue_row">
                              <Col md="6" lg="6">
                                <FormField
                                  showLabel
                                  showPlaceholder={true}
                                  placeholder="Select Venue"
                                  type="select"
                                  name="venue_id"
                                  label="Select Venue *"
                                  errors={errors}
                                  touched={touched}
                                  value={values.venue_id}
                                  options={this.transformValue(
                                    venues,
                                    "venues"
                                  )}
                                  onChange={({ target }) => {
                                    const { name, value } = target || {};
                                    handleChange({
                                      target: { name, value },
                                    });
                                    if (value !== ""  && ['1','2' ,'7'].includes(value)) {
                                      this.setState({
                                        isOpen: true,
                                      });
                                    }
                                  }}
                                />

                                {parseInt(values.venue_id)  === 4 && !connectedVenues.some(data => parseInt(data.app_id) === ZOOM_APP_ID) && 
                                  <p className="venue_not_connect">
                                    Zoom is not connected. Visit the 
                                    <Link to={"/integrations/zoom"} > Zoom integration page </Link>  
                                    to connect your account
                                  </p>
                                }

                                { parseInt(values.venue_id) === 3 && !connectedVenues.some(data => parseInt(data.app_id) === GOOGLE_MEET_APP_ID) && 
                                  <p className="venue_not_connect">
                                    To enable Google Meet for your events, please connect your
                                    <a href={`${BACKEND_API_BASE_URL}google-calendar-auth/${getAdminBusinessId()}`}> Google Calendar </a> first.
                                    This ensures all events are synced properly.
                                  </p>
                                }

                                { parseInt(values.venue_id) === 5 && !connectedVenues.some(data => parseInt(data.app_id) === MICROSOFT_TEAMS_ID) && 
                                  <p className="venue_not_connect">
                                    Microsoft Teams is not connected. Visit the 
                                    <Link to={"/integrations/ms-teams"} > Microsoft Teams integration page </Link>  
                                    to connect your account
                                  </p>
                                }

                              </Col>
                              
                              <Col md="4" lg="4">
                                {!isEmpty(values.venue_id) && !['3', '4', '5', '6'].includes(values.venue_id) && (
                                  <EventTypeModal
                                    isOpen={isOpen}
                                    touched={touched}
                                    formValues={values}
                                    errors={errors}
                                    defaultValue={values.venue_id}
                                    onChange={(name, value) => {
                                      handleChange({
                                        target: { name, value },
                                      });
                                    }}
                                    setFieldTouched={setFieldTouched}
                                    venues={this.transformValue(venues, "venues")}
                                    onToggle={this.toggleModal}
                                  />
                                )}
                              </Col>
                            </Row>
                          </div>
                          <div className="event-card-footer">
                            <Row>
                              <Col md="3" lg="3" className="mt-3">
                                <Button
                                  className="btn btn-danger"
                                  type="button"
                                  disabled={isLoading}
                                  onClick={this.onCancel}
                                >
                                  Cancel
                                </Button>
                              </Col>
                              <Col md="3" lg="3" className="mt-3">
                                <Button
                                  className="btn btn-outline"
                                  type="button"
                                  disabled={isLoading}
                                  onClick={this.onSaveAsDraft}
                                >
                                  Save as Draft
                                </Button>
                              </Col>

                              <Col md="3" lg="3" className="mt-3">
                                <Button
                                  className="btn btn-success"
                                  type="button"
                                  disabled={isLoading}
                                  onClick={this.onCancel}
                                >
                                  Back
                                </Button>
                              </Col>

                              <Col md="3" lg="3" className="mt-3">
                                <Button
                                  type="submit"
                                  className="btn btn-app"
                                  disabled={isLoading 
                                    || 
                                    (parseInt(values.venue_id)  === 4 && !connectedVenues.some(data => parseInt(data.app_id) === ZOOM_APP_ID))
                                    ||
                                    (parseInt(values.venue_id)  === 3 && !connectedVenues.some(data => parseInt(data.app_id)  === GOOGLE_MEET_APP_ID))
                                  }
                                >
                                  Next Step
                                </Button>
                              </Col>
                            </Row>
                            {errorMessage !== "" && (
                              <Alert
                                color="danger"
                                className="mt-4 text-center p-10"
                              >
                                {errorMessage}
                              </Alert>
                            )}
                          </div>
                        </Form>
                      );
                    }}
                  </Formik>
                )}
              </div>
            </Col>
            <Col lg="3">
              <SidebarProgress props={this.props} />
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  featureAccess: state.featureAccess,
});

const ConnectedAddNewEvent = connect(mapStateToProps, {
  getEventTypes,
  getVenues,
  getEventTypeDetails,
  saveEventType,
  saveAdHocEvent,
  sendGetRequest
})(withRouter(AddNewEvent));

/**
 * Functional wrapper that enforces the feature gate before rendering step 1.
 * If the user navigates directly to ?type=paid-event without the Collect Payments
 * feature, they are immediately redirected to the event type selection page.
 */
const AddNewEventGuarded = (props) => {
  const search = window.location.search;
  const { type } = qs.parse(search);
  const isPaidEvent = type === "paid-event";
  const isEdit = /\/admin\/events\/\d+\/create/.test(window.location.pathname);

  useFeatureRedirect(
    FEATURE_IDS.COLLECT_PAYMENTS,
    "/admin/events/create/list",
    isPaidEvent
  );

  usePlanLimitRedirect("events", "/admin/events/create/list", !isEdit);

  return <ConnectedAddNewEvent {...props} />;
};

export default AddNewEventGuarded;
